import { fetchGetNewbuildingLayouts } from '../../shared/repositories/newbuilding-card/v1/get-newbuilding-layouts';
import { assertBadHttpStatus } from './assert';
export async function fetchLayouts(_ref) {
  let {
    params,
    httpApi,
    logger
  } = _ref;
  try {
    const response = await fetchGetNewbuildingLayouts({
      httpApi,
      parameters: params,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    assertBadHttpStatus(response);
    const typedResponse = response;
    return typedResponse.response.layoutsInfo || null;
  } catch (error) {
    logger.error(error, {
      domain: 'src/services/fetchLayouts'
    });
    return null;
  }
}